// Recovery codes are shown once. This keeps them in memory only (never in storage) so the
// print page can show them; a page reload forgets them.
let codes: string[] | null = null;

export const setRecoveryCodes = (next: string[]) => {
  codes = next;
};
export const getRecoveryCodes = () => codes;
export const clearRecoveryCodes = () => {
  codes = null;
};
